var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 662,
    viewBox: "0 0 547 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-315.717 0L-315.717 662M-211.752 0L-211.753 662M-107.788 0L-107.788 662M-3.8232 0L-3.82323 662M100.141 0L100.141 662M204.106 0L204.106 662M308.071 0L308.071 662M412.035 0L412.035 662M516 0L516 662M-316 643.49H515.717M-316 539.341L515.717 539.341M-316 435.192L515.717 435.192M-316 331.042L515.717 331.042M-316 226.893L515.717 226.893M-316 122.743L515.717 122.743M-316 18.5937L515.717 18.5937",
    stroke: "url(#paint0_radial_9562_72389)",
    strokeOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9562_72389",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100 331) rotate(90) scale(331 416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147AFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingRightBg);
export default __webpack_public_path__ + "static/media/LandingRightBg.f934bc54b18570451ac672f3601cc73b.svg";
export { ForwardRef as ReactComponent };